import { useAuth } from "../../store/AuthContext/AuthContext";
import Button from "../../components/Button/Button";
import { GoogleIcon } from "../../Icons/GoogleIcon";
import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";
import Typography from "../../components/Typography/Typography";

const CLIENT_ID = "bo24stke7qeq3l76saqttte3j";
const REDIRECT_URI = "http://localhost:3000/client/library";
const AUTH_URL = `https://eu-west-3cee3sfvyn.auth.eu-west-3.amazoncognito.com/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URI}&response_type=CODE&client_id=${CLIENT_ID}&scope=openid+profile+email`;

const Register = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {

    window.location.href = "/client/library";
  }

  return (
    <div className="overflow-hidden ">
      <OnboardingLayout hasProgress={false}>
        <div className="pt-12 pb-14 md:mx-auto md:w-[40rem] w-auto px-4 flex flex-col gap-[36px]">
          <div className="flex flex-col gap-2 md:gap-2">
            <Typography
              align="center"
              family="serif"
              size="32"
              desktopSize="48"
              weight="sb"
              color="black"
            >
              La soluzione giusta
              <br />è pronta per te!
            </Typography>
            <Typography
              align="center"
              size="16"
              desktopSize="20"
              color="gray-600"
            >
              Registrati e scopri come abbiamo adattato il percorso alle tue
              esigenze!
            </Typography>
          </div>

          <div className="flex flex-col gap-4 w-full">
            <Link to="/register-form">
              <Button
                text="Registrati con Email"
                width="full"
                size={window.innerWidth >= 768 ? "lg" : "md"}
                licon={<Mail size={24} />}
              />
            </Link>

            <div className="flex items-center gap-3">
              <div className="w-1/2 border border-gray-200" />
              <Typography size="16" weight="md" color="gray-600">
                oppure
              </Typography>
              <div className="w-1/2 border border-gray-200" />
            </div>

            <a href={AUTH_URL} className="block w-full">
              <Button
                text="Registrati con Google"
                width="full"
                type="bw"
                size={window.innerWidth >= 768 ? "lg" : "md"}
                licon={<GoogleIcon size={24} />}
              />
            </a>
          </div>

          <Typography
            align="center"
            size="16"
            desktopSize="12"
            color="gray-600"
          >
            Registrandoti dichiari di aver letto e accettato i nostri
            <Typography color="accent" weight="md" underline={true}>
              <Link to={"/legal/privacy"}>{" "}Termini di Servizio{" "}</Link>
            </Typography>
            e la nostra
            <Typography color="accent" weight="md" underline={true}>
              <Link to={"/legal/privacy"}>{" "}Informativa sulla privacy{" "}</Link>
            </Typography>
          </Typography>
        </div>

        <div className="absolute -bottom-16 left-0 w-full pointer-events-none">
          <img
            src="assets/images/illustrations/graduating.png"
            alt="Illustrazione di una persona che si laurea"
            className="absolute bottom-0 lg:-left-10 left-1/2 lg:-translate-x-0 -translate-x-1/2 w-[18rem] h-[18rem] md:w-[25rem] md:h-[25rem] object-contain"
          />
          <img
            src="assets/images/illustrations/yeah.png"
            alt="Illustrazione di una persona che si laurea"
            className="hidden lg:block absolute bottom-0 lg:-right-10 right-1/2 lg:-translate-x-0 -translate-x-1/2 w-[25rem] h-[25rem] object-contain"
          />
        </div>
      </OnboardingLayout>
    </div>
  );
};

export default Register;